import React from 'react';
// import  from './reviewDetails';
import ReviewDetailsCard from '../../../collectPayment/reviewAndReceipt/reviewDetails';
import { getCreateExamReceiptReqObj } from '../../context/utils';
import { httpPostCall } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';
import { useGetExamChargesContext } from '../../context';

const ReviewAndReceipt = ({ module }) => {

  const { studentDetails1 } = useGetExamChargesContext();

  const createReceipt = async (state, ...rest) => {

    const reqObj = getCreateExamReceiptReqObj(...rest);
    return await httpPostCall(`${endpoint.examCharges.createExamReceipt}`, reqObj, 'post', true, { state });
  }

  return (
    <>
      <ReviewDetailsCard module={module} createReceipt={createReceipt} studentDetails={studentDetails1} />
    </>
  )
}

export default ReviewAndReceipt